import styled from 'styled-components';

export const StyledTableCard = styled.div`
    display: flex;
    cursor: pointer;
    justify-content:center;
    align-items: center;
    ${({ theme }) => `background-color: ${theme.palette.primary.main}`};
    ${({ theme }) => `${theme.typography.caption}`};
    user-select: none;
    border: none;
    box-shadow: 0px 10px 24px rgba(0, 0, 0, 0.15);
    border-radius: 10px;
    text-align: center;
    ${({ theme }) => `
        color: ${theme.palette.getContrastText(theme.palette.primary.main)};
        
        &:hover {
            background-color: ${theme.palette.primary.light};
            color: ${theme.palette.getContrastText(theme.palette.primary.light)};
        }

        &:active {
            ${`opacity: ${theme.palette.action.disabledOpacity}`}
        }
    `}
`;
